import React from 'react';
import { DeviceSize, useWindowSize } from '../../../../hooks/useWindowSize';
import { AULink } from 'components/AULink';
import './styles.css';

const IMAGE_SRC_DESKTOP = 'https://au-prod-media.s3.us-west-2.amazonaws.com/media/wedding-layflat-link-desktop.png';
const IMAGE_SRC_MOBILE = 'https://au-prod-media.s3.us-west-2.amazonaws.com/media/wedding-layflat-link-mobile.png';
const WEDDING_LAYFLAT_LINK_PATH = '/photo-books/wedding-layflat-photo-album';

export const WeddingLayflatLink: React.FC = () => {
  const { deviceSize } = useWindowSize();
  const isDesktop = deviceSize === DeviceSize.LARGE;

  const imageSrc = isDesktop ? IMAGE_SRC_DESKTOP : IMAGE_SRC_MOBILE;

  return (
    <AULink
      id="wedding-layflat-link"
      className="wedding-layflat-link"
      path={WEDDING_LAYFLAT_LINK_PATH}
      onMouseOver={e => e.stopPropagation()}
    >
      <img src={imageSrc} alt="Wedding Layflat" />
      <span>Shop Our Wedding Layflat Album →</span>
    </AULink>
  );
};
